//@ts-ignore
import { tw } from "@careinfo/tailwind";
import SafeHTMLRenderer from "../SafeHTMLRenderer";
import "./style.css";

const NoticePopup = (props: any) => {
  const { NoticeData } = props;

  return (
    <div className={tw`flex flex-col justify-center items-center h-auto  mt-4`}>
      <p className={tw`text-lg font-semibold`}>{NoticeData?.title}</p>
      <div className={tw`border px-4 py-2 rounded-lg mt-2 `}>
        <SafeHTMLRenderer html={NoticeData?.content} className="ProseMirror" />
      </div>
    </div>
  );
};

export default NoticePopup;
